import { Toaster } from "./components/ui/toaster";
import { Toaster as Sonner } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "./utils/routes"; // Import the full routes object
import NotFound from "@/components/common/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      {/* Remove the extra BrowserRouter here, it's already at the top level */}
      <Routes>
        {/* Default redirect to dashboard (no auth required for testing) */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* Public Routes */}
        {routes[0].routes.map(route => (
          <Route
            key={route.name}
            path={route.path}
            element={<route.element />}
          />
        ))}

        {/* Protected Routes (now public for testing) */}
        {routes[1].routes.map(route => (
          <Route
            key={route.name}
            path={route.path}
            element={<route.element />}
          />
        ))}

        {/* Catch-all for Not Found page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
